import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#53A2D9" d="M66 53h13v13H66z" />
      <path fill="#7BB835" d="M75 40h13v13H75zM105 48h13v13h-13z" />
      <path fill="#15539F" d="M60 66h13v13H60zM84 53h13v13H84zM115 61h13v13h-13z" />
      <path fill="#7BB835" d="M79 66h13v13H79z" />
      <path fill="#53A2D9" d="M97 61h13v13H97z" />
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M27.017 45.916h-5.511v-4h36.017v4h-6.81v32.87H92.29l4.95-4.95h40.2l-16.168 35.56H13.294V78.049h13.723V45.916zm20.196 0H30.517v35.633H16.794v24.347H119.02l12.985-28.56H98.69l-4.95 4.95H47.213v-36.37zm-9.942 6.674h2.769v5.381h-2.77v-5.38zm0 7.952h2.769v5.38h-2.77v-5.38z"
      />
    </g>
  </Svg>
)
